import {
    Container,
    BackToHomeScreen,
    PolicyContainer,
    Heading,
    Paragraph,
    NavigationLink,
    NavigationLinkContainer,
    NavigationLinkDivider,
    Li,
} from '../styled'
import NavigationArrowLink from '../../../../reusable/buttons/NavigationArrowLink'
import { useHistory } from 'react-router'
import { useTypedSelector } from '../../../../../hooks'

const AuksjonenPolicy = () => {
    const history = useHistory()

    const { companyName, organizationalCode } = useTypedSelector(
        (state) => state.whistleblower
    )

    const { lineOfContacts } = useTypedSelector((state) => state.lineOfContact)

    return (
        <>
            <BackToHomeScreen>
                <NavigationArrowLink
                    onClickCallback={() => {
                        history.push(
                            `/organization/${organizationalCode}/whistleblower`
                        )
                    }}
                    linkText={'Tilbake til hjemmesiden'}
                />
            </BackToHomeScreen>
            <Container>
                <NavigationLinkContainer>
                    <NavigationLink active={true}>{companyName}</NavigationLink>
                    <NavigationLinkDivider />
                    <NavigationLink active={false}>
                        Varslingsrutine
                    </NavigationLink>
                </NavigationLinkContainer>
                <PolicyContainer>
                    <Heading>{companyName}s Varslingsrutine</Heading>

                    <Heading>Innledning</Heading>
                    <Paragraph>
                        Varsling er å si ifra om kritikkverdige forhold til noen
                        som kan gjøre noe med det.
                    </Paragraph>
                    <Paragraph>
                        Vi ønsker at kritikkverdige forhold avdekkes slik at vi
                        kan rette opp i dem. Derfor oppfordrer vi til å varsle
                        om kritikkverdige forhold.
                    </Paragraph>
                    <Paragraph>
                        I de fleste tilfeller vil det være mest hensiktsmessig å
                        snakke med nærmeste leder eller et medlem av ledelsen.
                        Situasjonen kan likevel fremstå annerledes, og da er det
                        også mulig å bruke varslingskanalen.
                    </Paragraph>
                    <Paragraph>
                        Varslingsordningen sikrer beskyttelse for personer som
                        varsler om alvorlige lovbrudd og forhold. Ordningen kan
                        brukes hvis du opplever, er kjent med eller har grunn
                        til å mistenke at det har forekommet slike brudd i
                        Auksjonen både i fortid, nåtid og nær fremtid. Rapporter
                        kan sendes inn anonymt eller konfidensielt.
                    </Paragraph>

                    <Heading>
                        Hva er varsling om kritikkverdige forhold?
                    </Heading>
                    <Paragraph>
                        Arbeidstakere kan alltid varsle om kritikkverdige
                        forhold etter arbeidsmiljøloven kapittel 2 A. Det samme
                        kan innleide arbeidstakere.
                    </Paragraph>
                    <Paragraph>
                        Med kritikkverdige forhold menes forhold som er i strid
                        med
                    </Paragraph>
                    <Paragraph>
                        <ul>
                            <Li>lover og regler (rettsregler)</Li>
                            <Li>skriftlige etiske retningslinjer</Li>
                            <Li>
                                etiske normer som det er bred tilslutning til i
                                samfunnet
                            </Li>
                        </ul>
                    </Paragraph>
                    <Paragraph>
                        Lovbrudd og straffbare forhold anses dermed alltid som
                        kritikkverdige forhold. Andre eksempler på
                        kritikkverdige forhold er
                    </Paragraph>
                    <Paragraph>
                        <ul>
                            <Li>fare for liv eller helse</Li>
                            <Li>fare for klima eller miljø</Li>
                            <Li>
                                korrupsjon eller annen økonomisk kriminalitet
                            </Li>
                            <Li>myndighetsmisbruk</Li>
                            <Li>uforsvarlig arbeidsmiljø</Li>
                            <Li>brudd på personopplysningssikkerheten</Li>
                        </ul>
                    </Paragraph>
                    <Paragraph>
                        Vær oppmerksom på at arbeidstaker kan ytre seg om lønn,
                        arbeidsmengde, fordeling av arbeidsoppgaver og
                        alminnelige samhandlingsutfordringer, uten at dette
                        regnes som varsling i samsvar med arbeidsmiljøloven. Det
                        er først når arbeidstaker sier ifra eller ytrer seg om
                        det loven definerer som et kritikkverdig forhold, at
                        ytringen er et varsel i lovens forstand.
                    </Paragraph>
                    <Paragraph>
                        Arbeidstakere kan også ha en plikt til å varsle etter
                        arbeidsmiljøloven, blant annet om man blir kjent med at
                        det foregår trakassering eller diskriminering på
                        arbeidsplassen, og om man blir oppmerksom på feil eller
                        mangler som kan medføre fare for liv og helse, og
                        vedkommende ikke selv kan rette på forholdet.
                        Varslingsplikt kan også følge av andre lovregler eller
                        av pliktene i en stilling.
                    </Paragraph>

                    <Heading>Fremgangsmåte for varsling</Heading>
                    <Paragraph>
                        En varsling kan gjøres enten anonymt eller konfidensielt
                        gjennom vårt varslingssystem Walor.
                    </Paragraph>
                    <Paragraph>
                        Førstnevnte innebærer at ingen personopplysninger deles,
                        mens sistnevnte innebærer at varsleren deler
                        personopplysninger. Du kan velge å varsle anonymt, men
                        dette kan legge begrensninger for våre muligheter til å
                        undersøke forholdene i varslingen. Vi oppfordrer derfor
                        til at du ikke velger å være anonym.
                    </Paragraph>
                    <Paragraph>
                        Hvis personopplysninger deles i varselet, er det bare de
                        som er autorisert til å undersøke saken, som får tilgang
                        til dem. Konfidensialiteten til det innsendte varselet
                        vil derfor uansett bli respektert.
                    </Paragraph>
                    <Paragraph>
                        Du kan varsle gjennom Walor, vårt varslingssystem.
                        Varselet går først til HR-ansvarlig.
                    </Paragraph>
                    <Paragraph>
                        Varselet vil bli behandlet av følgende saksbehandlere:
                    </Paragraph>
                    <Paragraph>
                        <ul>
                            {lineOfContacts.map((lineOfContact) => (
                                <Li
                                    key={lineOfContact.id}
                                    style={{ paddingBottom: '1rem' }}
                                >
                                    {lineOfContact.first_name}{' '}
                                    {lineOfContact.last_name}
                                    {' - '}
                                    {lineOfContact.contact_information.position}
                                </Li>
                            ))}
                        </ul>
                    </Paragraph>
                    <Paragraph>
                        Link:{' '}
                        <a
                            href={`https://app.whistleblower.walor.io/organization/${organizationalCode}/whistleblower`}
                        >
                            {`https://app.whistleblower.walor.io/organization/${organizationalCode}/whistleblower`}
                        </a>
                    </Paragraph>
                    <Paragraph>
                        Arbeidstaker kan også alltid varsle eksternt til en
                        offentlig tilsynsmyndighet eller en annen offentlig
                        myndighet.
                    </Paragraph>
                    <Paragraph>
                        Arbeidstaker kan kun varsle eksternt til media eller
                        offentligheten for øvrig dersom
                    </Paragraph>
                    <Paragraph>
                        <ul>
                            <Li>
                                arbeidstaker er i aktsom god tro om innholdet i
                                varselet,
                            </Li>
                            <Li>
                                varselet gjelder kritikkverdige forhold som har
                                allmenn interesse, og
                            </Li>
                            <Li>
                                arbeidstaker først har varslet internt, eller
                                har grunn til å tro at intern varsling ikke vil
                                være hensiktsmessig.
                            </Li>
                        </ul>
                    </Paragraph>

                    <Heading>Behandling og oppfølging av varsling</Heading>
                    <Paragraph>
                        HR-ansvarlig vil få beskjed om varselet og varsler få
                        beskjed om at varselet er mottatt senest innen 2
                        arbeidsdager etter at varselet er mottatt.
                    </Paragraph>
                    <Paragraph>
                        Den som mottar varslingen, har ansvar for å følge opp
                        meldingen og for å sørge for at denne behandles av rett
                        instans/person i selskapet.
                    </Paragraph>
                    <Paragraph>
                        Når det opprettes et varsel, får du mulighet til å logge
                        deg inn i systemet og se om saksbehandleren har stilt
                        ytterligere spørsmål om saken eller bedt om ytterligere
                        dokumentasjon. Eventuell etterfølgende dialog avhenger
                        utelukkende av varslerens vilje til å logge inn i
                        systemet og svare på saksbehandlerens spørsmål.
                    </Paragraph>
                    <Paragraph>
                        Dersom det viser seg at en melding ikke er en varsling
                        om kritikkverdige forhold i henhold til
                        arbeidsmiljøloven kapittel 2A, skal den som sendte
                        meldingen informeres om vurderingen og eventuell videre
                        oppfølging av forholdet i meldingen.
                    </Paragraph>
                    <Paragraph>
                        Varslingssaker skal undersøkes så raskt som mulig og med
                        de ressurser som anses nødvendige for å oppfylle
                        arbeidsmiljølovens krav. Når beslutning i saken er tatt,
                        skal den som har varslet informeres om beslutningen så
                        langt dette ikke er i strid med lov. Den som har varslet
                        eller andre involverte i saken, har i alminnelighet ikke
                        krav på innsyn i dokumentene i en varslingssak.
                    </Paragraph>
                    <Paragraph>
                        Arbeidsgiver skal følge reglene i personopplysningsloven
                        ved behandlingen av varslingssaker.
                    </Paragraph>
                    <Paragraph>
                        Den som har varslet i tråd med arbeidsmiljøloven skal
                        være vernet mot enhver ugunstig handling som er en
                        reaksjon på at vedkommende har varslet
                        ("gjengjeldelse").
                    </Paragraph>
                    <Paragraph>
                        Varslingskanalen drives av Walor ApS, som er en
                        uavhengig tredjepart som garanterer for systemets
                        sikkerhet. Systemet logger ikke IP-adresser og
                        maskin-ID-er og krypterer alle data som behandles. Det
                        er kun den ansvarlige saksbehandleren som har tilgang
                        til rapporten.
                    </Paragraph>
                    <Paragraph>Utarbeidet sammen med AMU 13.05.2026</Paragraph>
                </PolicyContainer>
            </Container>
        </>
    )
}

export default AuksjonenPolicy
